var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 4,
    fill: "#E0F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7 19.9V28.9H16.3V15.1H23.2V19C23.2 19.4971 23.6029 19.9 24.1 19.9H27.7ZM27.2551 18.7H24.4V15.6546L27.2551 18.7ZM28.9 19.3V29.5C28.9 29.8314 28.6313 30.1 28.3 30.1H15.7C15.3686 30.1 15.1 29.8314 15.1 29.5V14.5C15.1 14.1687 15.3686 13.9 15.7 13.9H23.8H24.14C24.3059 13.9 24.4643 13.9687 24.5778 14.0897L28.7377 18.5269C28.842 18.6381 28.9 18.7849 28.9 18.9373V19.3Z",
    fill: "url(#paint0_linear_1781_6539)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1781_6539",
    x1: 34.3984,
    y1: 12.5711,
    x2: 11.013,
    y2: 27.2323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FB073"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.1b71acb974c6aed33c52096bacd4be24.svg";
export { ForwardRef as ReactComponent };